import React from 'react';
import startCase from 'lodash/startCase';
import capitalize from 'lodash/capitalize';
import './index.scss';
import Slideshow from './Slideshow';

const SiteDetails = ({ selectedSiteProps, columns, setSelection }) => {
  return <React.Fragment>
    <div className="block__sidebar--root">
      {((selectedSiteProps.image_links || []).length > 0) &&
        <Slideshow urls={(selectedSiteProps.image_links || []).filter(l => l.trim() != '')} />
      }
      <div className={["bp3-running-text", 'block__sidebar'].join(' ')}>
        {columns.map(k => {
          let content = selectedSiteProps[k];
          if (!content || content === '') return '';
          if (String(content).startsWith('http') || String(content).startsWith('www')) {
            return <React.Fragment key={k}>
              <strong> {startCase(k)} </strong>
              <a target="_blank" rel="noopener noreferrer" href={content}>{content}</a>
            </React.Fragment>
          }
          if (k.toLowerCase() === 'height') {
            return <React.Fragment key={k}>
              <strong> Height </strong>
              <p> {content} meters </p>
            </React.Fragment>
          }
          return <React.Fragment key={k}>
            <strong> {startCase(k)} </strong>
            <p> {content} </p>
          </React.Fragment>

        })}
      </div>
    </div>
  </React.Fragment>
}


export default SiteDetails;
